import React from 'react'
import ReactModal from 'react-modal';

import InnerHTML from 'dangerously-set-html-content';
import { ReactComponent as XIcon } from 'assets/img/close.svg';


interface IProductTourVideo {
    isdisplayVideo: boolean
    setDisplayVideo: (isdisplayVideo: boolean) => void
    videoId: number
    sectionTitle: string
}

const GetStartedVideosDispaly: React.FC<IProductTourVideo> = ({ isdisplayVideo, setDisplayVideo, videoId, sectionTitle }) => {

    const videoEmbed = `<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/${videoId}?h=6defe4bf87&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="GroupApp Product Demo"></iframe></div>`


    return (
        <>
            <ReactModal
                isOpen={isdisplayVideo}
                style={{
                    content: {
                        width: "1102px",
                        maxWidth: "calc(100vw - 10px)",
                        borderRadius: '0.5rem',
                        top: "50%",
                        left: "50%",
                        right: "auto",
                        bottom: "auto",
                        transform: "translate(-50%, -50%)",
                        position: "fixed",
                        background: "white",
                        border: 0,
                        padding: 0,
                        boxShadow: '1px 1px 10px rgba(0, 0, 0, 0.05)',
                    },
                    overlay: {
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        zIndex: 2147483647,
                    }
                }}
            >
                <div className="gp-onboarding-message-container">
                    <div className="gp-onboarding-message-content-container">
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}>
                            <h1 className="gp-onboarding-message-content-title">{sectionTitle}</h1>
                            <button
                                className="gp-onboarding-message-footer-button"
                                onClick={() => setDisplayVideo(false)}
                            >
                                <XIcon />
                            </button>
                        </div>

                        <div className="gp-onboarding-message-content-video-container">
                            <InnerHTML html={videoEmbed} />
                        </div>
                    </div>
                </div>
            </ReactModal>
        </>
    )
}

export default GetStartedVideosDispaly